import { useEffect } from "react";
import { captureExtensionConnectContext } from "@/lib/extensionConnect";

export function AuthBootstrap({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    captureExtensionConnectContext(window.location.search);
  }, []);

  return children;
}
